import { Alert } from "@mui/material";
import { useActiveShow } from "common-fe";
import { isVenueTimezoneConfigured } from "common-fe/venueTime";
import { useTranslation } from "i18n-fe";
import StationExceptionLine from "./StationExceptionLine";

// #3455 -- "This show has no venue timezone. Ride times may be wrong. Set it on
// the venue." A missing venue timezone is a setup gap only an admin can close,
// so Score Admin says it (the scribe-side warning is removed by #3437).
// Advisory only: it gates nothing.
//
// "Configured" is common-fe's isVenueTimezoneConfigured, the SAME function the
// scribe's VenueClock uses, not a copy. It renders nothing until the active show
// has loaded (an unknown show is not an unconfigured one). Both surfaces that
// mount it always display the active show, so no showId is passed.
export default function NoVenueTimezoneBanner({ compact = false }) {
  const { t } = useTranslation("scoreadmin");
  const { activeShow } = useActiveShow();
  if (!activeShow) return null;
  if (isVenueTimezoneConfigured(activeShow.venueTimezone)) return null;

  if (compact) {
    return (
      <StationExceptionLine
        severity="warning"
        testId="no-venue-timezone-banner"
        text={t("stationMonitor.noVenueTimezone.message")}
      />
    );
  }

  return (
    <Alert severity="warning" variant="outlined" data-testid="no-venue-timezone-banner" sx={{ mb: 2 }}>
      {t("stationMonitor.noVenueTimezone.message")}
    </Alert>
  );
}
